import { Link } from 'react-router-dom';
import InfoCard from '../../../components/info-card';

const NotFound = () => {
    return (
        <InfoCard>
            Sayfa bulunamadı.<Link to="/">Ana Sayfa</Link>
        </InfoCard>
    );
};
export default NotFound;
